import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';

import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import { withStyles } from "@mui/styles";
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import BlockIcon from '@mui/icons-material/Block';
import EditIcon from '@mui/icons-material/ModeEditOutlined';
import PersonIcon from '@mui/icons-material/Person';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import {InputAdornment} from "@mui/material";

import PhoneIcon from "@mui/icons-material/Phone";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
const headCells = [


 
  
  { id: 'vm_vendorname', numeric: false, label: 'Name' },
  { id: 'vm_contactperson', numeric: false, label: 'Contact Person' },
  { id: 'pj_phoneno', numeric: false, label: 'Phone No.' },
  { id: 'vm_gstno', numeric: false, label: 'GSTIN' },
    { id: 'type', numeric: false, label: 'Type' },
   { id: '',  label: '' },
  ]
  
  

 
 function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
 
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class Vendormaster extends Component {
	
    constructor(props) {
    super(props);
   
      this.state = {redirect: false,
      Vendordata:[],vmid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
	 
	  order:'desc' ,orderBy:'',names:'',searchcustomer:'',vmstatus:'',
	          
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   this.addVendorboxRef = React.createRef();
	}
	
	updateDonenewParent = (text) => { this.apicall(this.state.page,this.state.rowsPerPage); }
	

		componentWillMount() { 
if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Vendor Management";   
			 this.props.parentsCallback(
           strname
        );
		
		document.title = "VR Builders - Vendor Management";
	

	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
}




 




  


handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 

myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}

apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxvendor.php?action=getall&vm_vendorname='+this.state.names+'&vm_vendortatus='+this.state.vmstatus+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  Vendordata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
			let copy=[50, 100, 150, 200, 250];
			
	  
	  this.setState({rowsPaging:copy});
	 
     }
	 else{
		   this.setState({Vendordata:[],totaldata:0});
	 }
 
    });
}





handleChangePage = (event, newPage) => {  
   
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    },()=>{  this.apicall(this.state.page,this.state.rowsPerPage); });
   
 
 
  };  
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
   


    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{  this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


      vendorDelete(vmid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('vm_id',vmid)
	 	   
formData.append('userid',localStorage.getItem("VRuserid"))	
	
	
	 axios.post(Serverurl+"ajaxvendor.php", formData, {
        }).then(res => {
    
           this.apicall(this.state.page,this.state.rowsPerPage); 
  
    
            });
 }
      }
	  vendorblock(vmid,state){  
	let strmsg=" Block";
	
	if(state===0)
	{
		strmsg=" Unblock";
	}
let r = window.confirm("Do you really want to "+strmsg+"?");
 if(r === true){ 
 var formData = new FormData();
     formData.append('action','statusupdate')
	 formData.append('vm_id',vmid)
	 	 formData.append('vm_isblock',state)   
formData.append('userid',localStorage.getItem("VRuserid"))	
	
	
	 axios.post(Serverurl+"ajaxvendor.php", formData, {
        }).then(res => {
        this.apicall(this.state.page,this.state.rowsPerPage); 
  
    
            });
 }
      }

Vendoraddbox(val){
        this.setState({ vmid: val },()=>{this.addVendorboxRef.current.handleClickOpen()});  
  
        
      }
render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
   


   <div className="searchmaster">


  
  <ul>
  

		
		<li>
 <p ><TextField
            variant="outlined"
            margin="normal" className="inputcntlparent" size="small"
            fullWidth value={this.state.names}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Vendor Name"
            name="names" onChange={this.myChangeHandler}
		
          /></p></li>
		
			 <li>
 	<p><FormControl  className="stadrp">			   
		<Select className="inputcntlparent" size="small"
		variant="outlined"
		native
		value={this.state.vmstatus}
		onChange={this.myChangeHandler}
		name='vmstatus'
		id='vmstatus'
		placeholder="Project Status"
		InputLabelProps={{
		shrink: true,
		}}
		>
			<option value="">Select</option>
		<option value={0}>Active</option>
		<option value={1}>In Active</option>

				
		</Select>
		</FormControl></p>	
</li>
<li>
<p className="searchbutton">
		<Button variant="contained" onClick={this.handleClickSearch} className={useStyles.submit} endIcon={<SearchIcon />}>
        Search
      </Button>	<Button variant="contained" onClick={()=>{this.Vendoraddbox(0)}} className="pointerbtn" endIcon={<AddIcon />}>
        New
      </Button></p>
</li>
	</ul>
		
	
		
</div>		




<Paper className={useStyles.root}>

<AddVendorbox  ref={this.addVendorboxRef} id={this.state.vmid}  updateDonenew={this.updateDonenewParent}/>
  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Vendordata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Vendordata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.vm_vendorname}</TableCell>
<TableCell>{item.vm_contactperson}</TableCell>
<TableCell>{item.vm_phoneno}</TableCell>
<TableCell>{item.vm_gstno}</TableCell>
<TableCell>{item.type}
	{item.vm_type==="3" &&(
	<>
-{item.se_servicename}

</>
	)}

</TableCell>
<TableCell align="left">


<div className="actionbtns">
<Button variant="contained" className="editbtn" onClick={()=>{this.Vendoraddbox(item.vm_id)}} endIcon={<EditIcon />}>

</Button>&nbsp;

 {item.vm_id!=="1" && (
 <React.Fragment>

{item.delcount==="0" && (<React.Fragment> 

<Button variant="contained" className="deletebtn" onClick={()=>{this.vendorDelete(item.vm_id)}} endIcon={<DeleteIcon />}>
  
</Button> </React.Fragment> )} &nbsp;
 
  {item.vm_isblock !=='1' &&(<React.Fragment> 
 
<Button variant="contained" className="statusbtnblock" onClick={()=>{this.vendorblock(item.vm_id,1)}} endIcon={<PersonIcon />}>
  
</Button> 
 </React.Fragment>)}
 {item.vm_isblock !=='0' &&(<React.Fragment> 
 
<Button variant="contained" className="statusbtn" onClick={()=>{this.vendorblock(item.vm_id,0)}} endIcon={<PersonOffIcon />}>
 
</Button> 
 </React.Fragment>)}
 
  </React.Fragment>
 
 )}
 </div>

 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colSpan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[50, 100, 150, 200, 250]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />   
  </Paper>
    

 </React.Fragment> 

 
 
  );
}
}

export class AddVendorbox extends Component{
constructor(props) {
      super(props)
	  
      this.state = {
		  
		   open:false,name:'',vm_id:0,phoneno:'',gstno:'',custmername:'',types:'',se_id:'',address:'',
      errormessage:'',erropen:false,servicedata:[],service:0,servicelabel:'Select Service', 
	  }
      
  }	
  
  
	onclickclose = (e) => {
	 this.setState({open:false});
}


   
handleClickOpen= (e) => {
 
  this.setState({open:!this.state.open,  name:'',gstno:'',custmername:'',types:'',se_id:'',phoneno:'', 
     errormessage:'',erropen:false,servicedata:[],service:0,servicelabel:'Select Service',
	  });
	  if(this.props.id!==0)
  {
		this.Vendorgetdata();
		 this.servicebind();
  }
	};
myChangeHandler = (event) => {
  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;

  if (nam === "phoneno") {
    if (val === '' || re.test(val)) {
      this.setState({ [nam]: val });
    }
  }  else {
    this.setState({ [nam]: val });
  }
}


 handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }

	Vendorgetdata() {
	
	   axios.get(Serverurl+'ajaxvendor.php?action=getall&vm_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
     
      vm_id:resp.data[0].vm_id,
	  name: resp.data[0].vm_vendorname,
      custmername: resp.data[0].vm_contactperson, 
		phoneno: resp.data[0].vm_phoneno, 
		gstno: resp.data[0].vm_gstno,
      address: resp.data[0].vm_address,
      types: resp.data[0].vm_type, 
       service: resp.data[0].vm_se_id, 
  
   
    }, () => {

          // Only load services if type is 3
          if(resp.data.vm_type === "3"){

            this.servicebind();   // keep your existing method

            // Poll or use a callback after servicedata is populated
            const interval = setInterval(() => {
              if(this.state.servicedata.length > 0){
                this.setState({ service: resp.data.vm_se_id }); // now bind the service
                clearInterval(interval);
              }
            }, 50);

          }

        });		
  }
  
});
}

handleUpdate = (e) => {
	const regst= /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/; 
	let role = this.state.role;
 let name = this.state.name;
 let custmername = this.state.custmername;
 let phoneno = this.state.phoneno;
  let gstno = this.state.gstno;
 let address = this.state.address;
 let types = this.state.types;

 let service = this.state.service;


  if(types==="")
{
	
	this.setState({errormessage:"Please Select Type ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}

   if(types==="3")
{
	 if(service==="0")
{
	
	
	this.setState({errormessage:"Please Select Service ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
}
	
} 


if(name==="")
{
	
	this.setState({errormessage:"Please Enter Name",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
}
if(custmername==="")
{
	
	this.setState({errormessage:"Please Enter Contact Person",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
}	
if(phoneno==="")
{
	
	this.setState({errormessage:"Please Enter Phone Number",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}

   if(types!=="1")
{
if(gstno==="")
{
	
	this.setState({errormessage:"Please Enter GST No.",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}else
{
	 if (!regst.test(gstno)) {
	 this.setState({errormessage:"Please Enter Valid GST No.",erropen:true});		
	return false; 
  }
}
}

	if(address==="")
{
	
	this.setState({errormessage:"Please Enter Address",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
}



   var formData = new FormData();
  
  
   if(this.state.vm_id===0)
	  {
		  formData.append('vm_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('vm_id',this.state.vm_id)
		
          }
	  
	  formData.append('action','insertorupdate') 
		formData.append('vm_type',types)
		if(types==="3")
		{			
		formData.append('vm_se_id',service)
		}
		else
		{
			formData.append('vm_se_id',0)
		}
		formData.append('vm_vendorname',name)
		formData.append('vm_contactperson',custmername)		
		formData.append('vm_phoneno',phoneno)
		formData.append('vm_gstno',gstno)
		formData.append('vm_address',address)
		

		
		formData.append('userid',localStorage.getItem("VRuserid"))
		 
		axios.post(Serverurl+"ajaxvendor.php", formData, {
        }).then(res => {
    
	    if(res.data === -1)
{ 
	 

		this.setState({errormessage:"Name Already Exist.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}
	
	
            this.props.updateDonenew();
    
        });
  
	
	this.setState({ open:false });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 
  myChangeHandlers = (e) => {
  const { name, value } = e.target;

  this.setState({
    [name]: value,
  });
;
  if (name === "types") {
	 
    if (value === "3") {
		
      this.servicebind();
    } else {
      this.setState({
        service: "",
      });
    }
  }
};
servicebind(){

    axios.get(Serverurl+'ajaxexpensesandservices.php?action=getall&se_type=2')
	
    
      .then((resp) => {    
     

	  
	  
	  let ServiceApi = resp.data.map(row => {
                      
          return {value: row.se_id, display:row.se_servicename}
        });
		
		 this.setState({
          servicedata: [{value: '', display:'Select Service'}].concat(ServiceApi)
        },()=>{console.log(this.state.servicedata)});
      }).then(data => {
		 
        
      
		
       
      })


   
	  
}

render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.onclickclose} maxWidth="md" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Vendor Management</DialogTitle>
      <DialogContent>
	  
<div className="formlist">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
		<ul className="vendorlist">
	
		<li>		
	 <p><span className="validation">*</span> Type</p>
		<p><FormControl  className="stadrp">			   
		<Select
		variant="outlined"
		native
		value={this.state.types} className="inputcntlparent" size="small"
		onChange={this.myChangeHandlers}
		name='types'
		id='types'
		InputLabelProps={{
		shrink: true,
		}}
		>
		<option value={0}>Select</option>
		<option value={1}>Mastri</option>
		<option value={2}>Vendor</option>
		<option value={3}>Service</option>		
		</Select>
		</FormControl></p>	</li>

{(this.state.types) === "3" && (<li>
		  <p>Service</p>
		  <p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.servicelabel, value: this.state.service}}
          onChange={this.myChangeHandler}
          id="service" 
		   value={this.state.service}   className="inputcntlparent" size="small"
		  name="service"
		inputProps={{tabIndex: "8"}}
		
        >
		{this.state.servicedata.map(sr => (
            <option  
            
              value={sr.value}
            >
              {sr.display}
            </option  >
          ))}
		
        </Select></FormControl>
		</p>
		  </li>		
)}			  
	<li><p> <span className="validation">*</span>Name</p>
	
	<p><TextField name="name" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   size="small"
	   value={this.state.name}
			 className="inputcntlparent" size="small"
			 
			   slotProps={{
    htmlInput: {
      maxLength: 150,
      tabIndex: 4
    },
    input: {
      endAdornment: (
        <InputAdornment position="end">
          <PersonIcon sx={{ color: "#206ccc", fontSize: 20 }} />
        </InputAdornment>
      )
    }
  }}
			
	   InputLabelProps={{ shrink: true }}
                          /></p></li>
<li><p> <span className="validation">*</span>Contact Person</p>
	
	<p><TextField name="custmername" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   size="small"
	   value={this.state.custmername}
			 
			 
			 className="inputcntlparent"  size="small"
			 
			 slotProps={{
    htmlInput: {
      maxLength: 150,
      tabIndex: 2
    },
    input: {
      endAdornment: (
        <InputAdornment position="end">
          <ContactPhoneIcon sx={{ color: "#206ccc", fontSize: 20 }} />
        </InputAdornment>
      )
    }
  }}
	   InputLabelProps={{ shrink: true }}
                          /></p></li>
						  
						  <li><p> <span className="validation">*</span> Phone No.</p>						  
	
	<p><TextField name="phoneno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   
	   value={this.state.phoneno}
			
			 className="inputcntlparent"  size="small"  
		slotProps={{
    htmlInput: {
      maxLength: 10,
      tabIndex: 3
    },
    input: {
      endAdornment: (
          <InputAdornment position="end">
        <PhoneIcon sx={{ color: "#206ccc", fontSize: 20 }} />
      </InputAdornment>
      )
    }
  }}
	   InputLabelProps={{ shrink: true }}
                          /></p>	</li>

<li><p> <span className="validation">*</span> GST No.</p>						  
	
	<p><TextField name="gstno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   
	   value={this.state.gstno}
			 className="inputcntlparent"  size="small"  
			  
			  		 slotProps={{
    htmlInput: {
      maxLength: 15,
      tabIndex: 3
    },
    input: {
      endAdornment: (
          <InputAdornment position="end">
        <ReceiptLongIcon  sx={{ color: "#206ccc", fontSize: 20 }} />
      </InputAdornment>
      )
    }
  }}
	   InputLabelProps={{ shrink: true }}
                          /></p>	</li>							  
						  
<li><p> <span className="validation">*</span>Address</p>
	
	<p><TextField name="address" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   size="small"
	   value={this.state.address}
			  multiline

    rows={3}
			 
		 slotProps={{
    htmlInput: {
     
      tabIndex: 4
    },
    input: {
      endAdornment: (
          <InputAdornment position="end" sx={{
          alignSelf: "flex-start",  
          mt: "6px"                 
        }}>
        <LocationOnIcon   sx={{ color: "#206ccc", fontSize: 20 }} />
      </InputAdornment>
      )
    }
  }}
	   InputLabelProps={{ shrink: true }}
                          /></p></li>						  
		
	

								  
						  
		
		
		
				
				


				
			  </ul>
		

		
		
       <div className="actionbtns">
<div className="cancelbtn">	  
        <Button className="frmsecondarybtn" onClick={this.onclickclose } color="secondary">
          Cancel
        </Button>
</div> 
<div className="savebtn">
        <Button className="frmPrimarybtn" onClick={this.handleUpdate} color="secondary">
          Save
        </Button>
		</div>
<div className="clear"></div>

 </div>     
			 
 </div> 		
 </DialogContent>
      
    </Dialog>
</React.Fragment>

) 
}	
}	